import type { QuestionFieldsForUpload } from '../../../firestore/SlideQuestion'
import { SlideQuestionType } from '../../../models/SlideQuestionType'
import type { ValidationContext, Validator } from './types'
import {
  validateTutorBot,
  validateModeratorBot,
  validateGraderBot,
  validateRolePlayBot,
} from './validateBots'
import { validateModerationTask } from './validateModerationTask'
import { validatePoll } from './validatePoll'
import { validateCustomPoll } from './validateCustomPoll'
import { validateSorting } from './validateSorting'
import { validateSortableStringList } from './validateSortableStringList'
import { validatePopUpInstructions } from './validatePopUpInstructions'
import { validateTalkTrack } from './validateTalkTrack'
import { validateTitle } from './validateTitle'
import { validateMultipleChoice } from './validateMultipleChoice'

const noopValidator: Validator = async () => []

export function validateSlideQuestion(
  context: ValidationContext,
  questionData: QuestionFieldsForUpload
) {
  const type = questionData.questionType
  switch (type) {
    case SlideQuestionType.title:
      return validateTitle(context, questionData)
    case SlideQuestionType.talkTrack:
      return validateTalkTrack(context, questionData)
    case SlideQuestionType.moderationTask:
      return validateModerationTask(context, questionData)
    case SlideQuestionType.tutorBot:
      return validateTutorBot(context, questionData)
    case SlideQuestionType.rolePlayBot:
      return validateRolePlayBot(context, questionData)
    case SlideQuestionType.moderatorBot:
      return validateModeratorBot(context, questionData)
    case SlideQuestionType.graderBot:
      return validateGraderBot(context, questionData)
    case SlideQuestionType.poll:
      return validatePoll(context, questionData)
    case SlideQuestionType.customPoll:
      return validateCustomPoll(context, questionData)
    case SlideQuestionType.sorting:
      return validateSorting(context, questionData)
    case SlideQuestionType.sortableStringList:
      return validateSortableStringList(context, questionData)
    case SlideQuestionType.popUpInstructions:
      return validatePopUpInstructions(context, questionData)
    case SlideQuestionType.multipleChoice:
      return validateMultipleChoice(context, questionData)
    case SlideQuestionType.displayModerationTask:
      return noopValidator(context, questionData)
    default:
      return []
  }
}

// async function validateMultipleQuestions(
//   context: ValidationContext,
//   questions: QuestionFieldsForUpload[]
// ) {
//   const errors = await Promise.all(
//     questions.map((question) => validateSlideQuestion(context, question))
//   )

//   return errors.flat()
// }
